import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  id: "home_m"
};
const _hoisted_2 = {
  class: "item-box"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "info-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "bottom_jt"
};
const _hoisted_9 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/science/gren_link.png",
  alt: ""
};
const _hoisted_10 = {
  key: 1,
  src: "https://www.mimodental.com/assets/imgData/img/science/fff_link.png",
  alt: ""
};
const _hoisted_11 = {
  key: 0,
  class: "bottom_link"
};
const _hoisted_12 = {
  class: "learn-more-box"
};
const _hoisted_13 = {
  key: 0,
  class: "vido_list"
};
const _hoisted_14 = {
  class: "vido_list_l"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  class: "list"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "dome_img"
};
const _hoisted_19 = ["src", "onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "learn-more-box"
};
const _hoisted_22 = {
  key: 1,
  class: "Expert_Popularization_m"
};
const _hoisted_23 = {
  class: "Popularization_list_m"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  style: {
    "color": "#cbcbcb"
  }
};
const _hoisted_26 = {
  key: 2,
  class: "learn-more-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "title top_title"
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/science/top_text.png",
    style: {
      "width": "100%"
    },
    alt: ""
  })], -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "item",
      key: index,
      style: _normalizeStyle('color:' + ($setup.tabIndex == index ? '#fff;' : '#41B9B2;') + 'background:' + ($setup.tabIndex == index ? '#41B9B2;' : '#fff;')),
      onClick: $event => $setup.tabClick(index)
    }, _toDisplayString(item.name), 13, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_4, [$setup.get_data.top?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($setup.get_data.top.length > 10 ? 10 : $setup.get_data.top.length, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "top_info",
      key: index,
      style: _normalizeStyle('background:' + ((index + 1) % 2 == 0 ? '#4fbeb7;' : '#fff;'))
    }, [_createElementVNode("div", {
      class: "img_info",
      onClick: $event => $setup.details($setup.get_data.top[index].id, index, true)
    }, [_createElementVNode("img", {
      class: "info-img",
      src: $setup.get_data.top[index]?.imgUrl,
      alt: ""
    }, null, 8, _hoisted_6)], 8, _hoisted_5), _createElementVNode("div", {
      class: "info_option",
      onClick: $event => $setup.details($setup.get_data.top[index].id, index, true)
    }, [_createElementVNode("h2", {
      class: "title",
      style: _normalizeStyle('color:' + ((index + 1) % 2 != 0 ? '#4fbeb7;' : '#fff;'))
    }, _toDisplayString($setup.get_data.top[index]?.title || ''), 5), _createElementVNode("div", {
      style: _normalizeStyle([{
        "height": "4px",
        "width": "5.5rem",
        "margin-bottom": "2rem",
        "border-radius": "10rem"
      }, 'background:' + ((index + 1) % 2 != 0 ? '#4fbeb7;' : '#fff;')])
    }, null, 4), _createElementVNode("span", {
      class: "content",
      style: _normalizeStyle(['color:' + ((index + 1) % 2 != 0 ? '#000;' : '#fff;'), {
        "font-family": "siyuan_Regular"
      }])
    }, _toDisplayString($setup.get_data.top[index].brief), 5)], 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [(index + 1) % 2 != 0 ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : (_openBlock(), _createElementBlock("img", _hoisted_10))]), (index + 1) % 2 != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)], 4);
  }), 128)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "learn-more",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.learnMore && $setup.learnMore(...args))
  }, "查看更多")]), $setup.get_data.boot.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h1", _hoisted_15, _toDisplayString($setup.tabList[$setup.tabIndex].name) + "注意事项", 1), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.boot.length > 4 ? 4 : $setup.get_data.boot.length, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "vido_dom",
      key: index
    }, [_createElementVNode("h1", _hoisted_17, _toDisplayString($setup.get_data.boot[index]?.title || ''), 1), _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
      class: "info-img",
      src: $setup.get_data.boot[index]?.imgUrl,
      onClick: $event => $setup.details($setup.get_data.boot[index].id, index)
    }, null, 8, _hoisted_19), _createElementVNode("div", null, [_createElementVNode("span", {
      class: "concat-us",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.show && $setup.show(...args))
    }, "联系我们"), _createElementVNode("span", {
      class: "guide",
      onClick: $event => $setup.details($setup.get_data.boot[index].id, index)
    }, "术后指引", 8, _hoisted_20)])])]);
  }), 128))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "learn-more",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.bootMore && $setup.bootMore(...args))
  }, "查看更多")]), $setup.answer.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("h2", null, _toDisplayString($setup.tabList[$setup.tabIndex].name) + "解答", 1), _createElementVNode("div", _hoisted_23, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (item, index) => {
    return _createElementVNode("div", {
      key: index,
      onClick: $event => $setup.details($setup.answer[index].id, index)
    }, [_createElementVNode("span", null, _toDisplayString($setup.answer[index].title || ''), 1), _createElementVNode("span", _hoisted_25, _toDisplayString($setup.answer[index].createTime), 1)], 8, _hoisted_24);
  }), 64))])])) : _createCommentVNode("", true), $setup.answer.length ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", {
    class: "learn-more",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.answerMore && $setup.answerMore(...args))
  }, "查看更多")])) : _createCommentVNode("", true)]);
}